import * as React from 'react';
import { Icon } from 'antd';

export default function TaxWarning(props) {
  return (
        <div style={props.style}>
            <Icon type="info-circle" theme="filled"
                style={{ color: '#FFC104', marginRight: '5px' }} />
            <span style={{ fontStyle: 'italic', fontSize: props.compareBidsStyle ? 10 : 12 }}>
                {`Bid Rank, Price per ${props.unit} & Total Price are exclusive of taxes`}
            </span>
        </div>
  );
}
